import _ from '@lodash';
import Avatar from '@mui/material/Avatar';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserToMessage, setUserToMessage, createExternalMessage} from 'app/store/externalMessageSlice';
import { useForm } from 'react-hook-form';
import { dispatchResultMessage } from '../utils';
import ControlledTextField from '../form/ControlledTextField';
import DefaultButton from '../layout/DefaultButton';

const schema = yup.object().shape({
  name: yup.string().required('You must enter a name'),
  email: yup.string().email('You must enter a valid email.').required('You must enter an email'),
  message: yup.string().required('You must enter a message'),
  phone: yup.string(),
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ExternalMessageDialog(props) {
  const dispatch = useDispatch();  
  const target = useSelector(selectUserToMessage);
  const { id, name, profileImageUrl} = target;
  const title = 'Send Message to ' + name;
  
  const { handleSubmit, formState, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      message: '',
    },
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;
  

  function handleCloseDialog() {
    
  }

  function handleDiscard() {
	  dispatch(setUserToMessage({}));
  }

  function onSubmit(data) {
    dispatch(createExternalMessage({targetId: id, name: data.name, email: data.email, message: data.message})).then((resp) =>
	{
		dispatchResultMessage(dispatch, resp, "Sent Message!");
	});
	dispatch(setUserToMessage({}));
  }
 

  return (
    <Dialog
      classes={{
        paper: 'w-full m-24',
      }}
      TransitionComponent={Transition}
      onClose={handleCloseDialog}
      open={Boolean(id)}
    >
      <AppBar position="static" color="secondary" elevation={0}>
	      <Toolbar className="flex w-full">
	        <Avatar src={profileImageUrl} />
	        <Typography className='ml-20' variant="subtitle1" color="inherit">
	          {title}
	        </Typography>
	      </Toolbar>
	  </AppBar>
	  
      <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-32 sm:pb-0' }}>
			  <ControlledTextField name="name" label="Your Name"
                             control={control} errors={errors}
             				 autoFocus required fullWidth />
              <ControlledTextField name="email" label="Your Email"
                             control={control} errors={errors}
             				 required fullWidth />
              <ControlledTextField name="message" label="Message"
                             control={control} errors={errors}
             				 required fullWidth multiline
             				 minRows={4} maxRows={8} />

          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">
            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
              <DefaultButton text="Cancel" onClick={handleDiscard} />
              <DefaultButton text="Send"
	              disabled={_.isEmpty(dirtyFields) || !isValid}
	              submit />
            </div>
          </DialogActions>
        </form>
        
    </Dialog>
  );
}

export default ExternalMessageDialog;
